export default __webpack_public_path__ + "static/media/home-bg-four.f8e77703.svg";